<script lang="ts">
	import AlgoliaResults from "@components/AlgoliaResults.svelte";
	import Searchbar from "@components/form/Searchbar.svelte";

	let { open = $bindable(false), searchText = $bindable("") }: { open?: boolean; searchText?: string } = $props();
</script>

<div class="relative grow">
	<Searchbar
		bind:value={searchText}
		name="websearch"
		placeholder="Vyhledávat"
		class={[
			"!text-xs/tight !border-0 pl-3 py-3 xl:py-2 placeholder:text-xs/tight",
			"xl:[--desktop:1]",
			open
				? "w-full xl:w-[50vw] grow xl:max-w-screen-md !rounded-b-none !border-[1.5px] !border-cmcprimary"
				: "w-full xl:w-[8.25rem]",
		]}
		iconClass="!size-6"
		onfocus={(): void => {
			open = true;
		}}
		onblur={(e: Event & { currentTarget: HTMLInputElement }): void => {
			if (
				getComputedStyle(e.currentTarget).getPropertyValue("--desktop") !== "1" &&
				!e.currentTarget.parentElement?.contains(document.activeElement)
			) {
				window.requestAnimationFrame(() => {
					open = false;
				});
			}
		}}
	/>
	{#if open}
		<div class="absolute rounded-b-lg drop-shadow-2xl top-full w-full z-50">
			<div class="overflow-auto max-h-72 rounded-b-lg">
				<AlgoliaResults {searchText} />
			</div>
		</div>
	{/if}
</div>
